/*=========================================================================================
  File Name: module-licenseinfo-getters.js
  Description: LicenseInfo Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import commonFunc from '@/common/commonFunction';
export default {
	getBankData: state => {
		return state.lstBank;
	}
};
